import { useParams } from 'react-router-dom';
import { ItemStatus, useOrder } from '../../../hooks/useOrder';

export const isItemReturnInProgress = (status: ItemStatus) => status === 'return_requested';

export const useReturnInProgressItems = () => {
  const { orderNumber } = useParams<{ orderNumber: string }>();
  const { orderItems = [] } = useOrder(orderNumber);

  return orderItems.filter(({ attributes: { status } }) => isItemReturnInProgress(status));
};
